import { useCategoryGroupingPageModelData } from "src/website-apps/responsive/stubhub-category-grouping/hooks/useCategoryGroupingPageModelData";
import { AppControl } from "./AppControl";

/**
 * Root Component for Category Grouping Route
 */
export const App = () => {
  const model = useCategoryGroupingPageModelData();

  return <AppControl model={model} />;
};
